/*
 * Generated by scripts/build-assets.mjs. Do not edit.
 *
 * Which games have their own picture. A game not listed here draws its
 * mark instead - see GameCard.
 */

export const GAME_ART: readonly string[] = [
  'cheat',
  'crazy-eights',
  'go-fish',
  'golf',
  'hearts',
  'klondike',
  'knockout-whist',
  'oh-hell',
  'pyramid',
  'rummy',
  'spades',
  'super-crazy-eights',
  'texas-holdem',
];
